import { BASE_API_PATH } from 'src/utils/constants';

export const SystemEndpoints = {
  AcademicYear: {
    getAll: `${BASE_API_PATH}/AcademicYear/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/AcademicYear/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/AcademicYear/GetById/${id}`,
    create: `${BASE_API_PATH}/AcademicYear/Create`,
    update: (id) => `${BASE_API_PATH}/AcademicYear/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/AcademicYear/Delete/${id}`,
  },
  AddressType: {
    getAll: `${BASE_API_PATH}/AddressType/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/AddressType/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/AddressType/GetById/${id}`,
    create: `${BASE_API_PATH}/AddressType/Create`,
    update: (id) => `${BASE_API_PATH}/AddressType/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/AddressType/Delete/${id}`,
  },
  AgeInterval: {
    getAll: `${BASE_API_PATH}/AgeInterval/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/AgeInterval/GetAllWithFilter`,
    getAllWithFilterAdmin: `${BASE_API_PATH}/AgeInterval/GetAllWithFilterAdmin`,
    getById: (id) => `${BASE_API_PATH}/AgeInterval/GetById/${id}`,
    create: `${BASE_API_PATH}/AgeInterval/Create`,
    update: (id) => `${BASE_API_PATH}/AgeInterval/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/AgeInterval/Delete/${id}`,
    duplicate: (sourceCompetitionId, destinationCompetitionId) =>
      `${BASE_API_PATH}/AgeInterval/Duplicate?SourceCompetitionId=${sourceCompetitionId}&DestinationCompetitionId=${destinationCompetitionId}`,
  },
  CertificateType: {
    getAll: `${BASE_API_PATH}/CertificateType/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/CertificateType/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/CertificateType/GetById/${id}`,
    create: `${BASE_API_PATH}/CertificateType/Create`,
    update: (id) => `${BASE_API_PATH}/CertificateType/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/CertificateType/Delete/${id}`,
  },
  CompetitionType: {
    getAll: `${BASE_API_PATH}/CompetitionType/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/CompetitionType/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/CompetitionType/GetById/${id}`,
    create: `${BASE_API_PATH}/CompetitionType/Create`,
    update: (id) => `${BASE_API_PATH}/CompetitionType/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/CompetitionType/Delete/${id}`,
  },
  DisabilityType: {
    getAll: `${BASE_API_PATH}/DisabilityType/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/DisabilityType/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/DisabilityType/GetById/${id}`,
    create: `${BASE_API_PATH}/DisabilityType/Create`,
    update: (id) => `${BASE_API_PATH}/DisabilityType/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/DisabilityType/Delete/${id}`,
  },
  DocumentFormatType: {
    getAll: `${BASE_API_PATH}/DocumentFormatType/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/DocumentFormatType/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/DocumentFormatType/GetById/${id}`,
    create: `${BASE_API_PATH}/DocumentFormatType/Create`,
    update: (id) => `${BASE_API_PATH}/DocumentFormatType/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/DocumentFormatType/Delete/${id}`,
  },
  DocumentType: {
    getAll: `${BASE_API_PATH}/DocumentType/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/DocumentType/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/DocumentType/GetById/${id}`,
    create: `${BASE_API_PATH}/DocumentType/Create`,
    update: (id) => `${BASE_API_PATH}/DocumentType/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/DocumentType/Delete/${id}`,
  },
  EmailType: {
    getAll: `${BASE_API_PATH}/EmailType/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/EmailType/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/EmailType/GetById/${id}`,
    create: `${BASE_API_PATH}/EmailType/Create`,
    update: (id) => `${BASE_API_PATH}/EmailType/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/EmailType/Delete/${id}`,
  },
  Gender: {
    getAll: `${BASE_API_PATH}/Gender/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/Gender/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/Gender/GetById/${id}`,
    create: `${BASE_API_PATH}/Gender/Create`,
    update: (id) => `${BASE_API_PATH}/Gender/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/Gender/Delete/${id}`,
  },
  Grade: {
    getAll: `${BASE_API_PATH}/Grade/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/Grade/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/Grade/GetById/${id}`,
    create: `${BASE_API_PATH}/Grade/Create`,
    update: (id) => `${BASE_API_PATH}/Grade/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/Grade/Delete/${id}`,
  },
  Language: {
    getAll: `${BASE_API_PATH}/Language/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/Language/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/Language/GetById/${id}`,
    create: `${BASE_API_PATH}/Language/Create`,
    update: (id) => `${BASE_API_PATH}/Language/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/Language/Delete/${id}`,
  },
  PhoneType: {
    getAll: `${BASE_API_PATH}/PhoneType/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/PhoneType/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/PhoneType/GetById/${id}`,
    create: `${BASE_API_PATH}/PhoneType/Create`,
    update: (id) => `${BASE_API_PATH}/PhoneType/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/PhoneType/Delete/${id}`,
  },
  ProjectFileType: {
    getAll: `${BASE_API_PATH}/ProjectFileType/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/ProjectFileType/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/ProjectFileType/GetById/${id}`,
    create: `${BASE_API_PATH}/ProjectFileType/Create`,
    update: (id) => `${BASE_API_PATH}/ProjectFileType/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/ProjectFileType/Delete/${id}`,
  },

  Semester: {
    getAll: `${BASE_API_PATH}/Semester/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/Semester/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/Semester/GetById/${id}`,
    create: `${BASE_API_PATH}/Semester/Create`,
    update: (id) => `${BASE_API_PATH}/Semester/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/Semester/Delete/${id}`,
  },
  VisaType: {
    getAll: `${BASE_API_PATH}/VisaType/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/VisaType/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/VisaType/GetById/${id}`,
    create: `${BASE_API_PATH}/VisaType/Create`,
    update: (id) => `${BASE_API_PATH}/VisaType/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/VisaType/Delete/${id}`,
  },
  MealPreference: {
    create: `${BASE_API_PATH}/MealPreference/Create`,
    update: (id) => `${BASE_API_PATH}/MealPreference/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/MealPreference/Delete/${id}`,
    getAll: `${BASE_API_PATH}/MealPreference/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/MealPreference/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/MealPreference/GetById/${id}`,
  },
  ShirtSize: {
    create: `${BASE_API_PATH}/ShirtSize/Create`,
    update: (id) => `${BASE_API_PATH}/ShirtSize/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/ShirtSize/Delete/${id}`,
    getAll: `${BASE_API_PATH}/ShirtSize/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/ShirtSize/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/ShirtSize/GetById/${id}`,
  },
  PerformanceType: {
    getAll: `${BASE_API_PATH}/PerformanceType/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/PerformanceType/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/PerformanceType/GetById/${id}`,
    create: `${BASE_API_PATH}/PerformanceType/Create`,
    update: (id) => `${BASE_API_PATH}/PerformanceType/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/PerformanceType/Delete/${id}`,
  },
  TransportationType: {
    getAll: `${BASE_API_PATH}/TransportationType/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/TransportationType/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/TransportationType/GetById/${id}`,
    create: `${BASE_API_PATH}/TransportationType/Create`,
    update: (id) => `${BASE_API_PATH}/TransportationType/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/TransportationType/Delete/${id}`,
  },
  SustainableDevelopmentGoal: {
    getAll: `${BASE_API_PATH}/SustainableDevelopmentGoal/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/SustainableDevelopmentGoal/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/SustainableDevelopmentGoal/GetById/${id}`,
    create: `${BASE_API_PATH}/SustainableDevelopmentGoal/Create`,
    update: (id) => `${BASE_API_PATH}/SustainableDevelopmentGoal/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/SustainableDevelopmentGoal/Delete/${id}`,
  },
  Notification: {
    send: `${BASE_API_PATH}/Notification/Send`,
    read: (id) => `${BASE_API_PATH}/Notification/Read?Id=${id}`,
    delete: (id) => `${BASE_API_PATH}/Notification/Delete?Id=${id}`,
  },
  FeedbackType: {
    getAll: `${BASE_API_PATH}/FeedbackType/GetAll`,
    getAllWithFilter: `${BASE_API_PATH}/FeedbackType/GetAllWithFilter`,
    getById: (id) => `${BASE_API_PATH}/FeedbackType/GetById/${id}`,
    create: `${BASE_API_PATH}/FeedbackType/Create`,
    update: (id) => `${BASE_API_PATH}/FeedbackType/Update/${id}`,
    delete: (id) => `${BASE_API_PATH}/FeedbackType/Delete/${id}`,
  },
};
